// src/configs/redux/reducer/filterReducer.js

import { lastMonth, today } from "src/utils/formatter";

const initialState = {
  search: "",
  perPage: 10,
  currentPage: 1,
  sortBy: "created_at",
  sortType: "desc",
  date: {
    dateFrom: lastMonth,
    dateTo: today,
  },
  fetchType: "list",
  activeTab: 1,
  warehouse: "",
  status: "",
  payment: "",
  outlet: "",
  division: "",
  role: "",
  employee: "",
  supplier: "",
  filterType: "",
  trip: "",
};

const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SEARCH":
      return {
        ...state,
        search: action.payload,
        currentPage: 1,
      };

    case "SET_PER_PAGE":
      return {
        ...state,
        perPage: action.payload,
        currentPage: 1,
      };

    case "SET_WAREHOUSE":
      return {
        ...state,
        warehouse: action.payload,
        currentPage: 1,
      };

    case "SET_CURRENT_PAGE":
      return {
        ...state,
        currentPage: action.payload,
      };

    case "SET_SORT":
      return {
        ...state,
        sortBy: action.payload.sortBy,
        sortType: action.payload.sortType,
        currentPage: 1,
      };

    case "SET_PAYMENT":
      return {
        ...state,
        payment: action.payload,
        currentPage: 1,
      };

    case "SET_OUTLET":
      return {
        ...state,
        outlet: action.payload,
        currentPage: 1,
      };

    case "SET_FILTER_TYPE":
      return {
        ...state,
        filterType: action.payload,
        currentPage: 1,
      };

    case "SET_DATE_RANGE":
      return {
        ...state,
        date: {
          ...state.date,
          ...action.payload,
        },
        currentPage: 1,
      };

    case "SET_STATUS":
      return {
        ...state,
        status: action.payload,
        currentPage: 1,
      };

    case "SET_DIVISION":
      return {
        ...state,
        division: action.payload,
        currentPage: 1,
      };

    case "SET_ROLE":
      return {
        ...state,
        role: action.payload,
        currentPage: 1,
      };

    case "SET_EMPLOYEE":
      return {
        ...state,
        employee: action.payload,
        currentPage: 1,
      };

    case "SET_SUPPLIER":
      return {
        ...state,
        supplier: action.payload,
        currentPage: 1,
      };
    case "SET_FETCH_TYPE":
      return {
        ...state,
        activeTab: action.payload.activeTab,
        fetchType: action.payload.fetchType,
        currentPage: 1,
      };

    case "SET_TRIP":
      return {
        ...state,
        trip: action.payload,
        currentPage: 1,
      };
    case "RESET_FILTER":
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default filterReducer;
